export default __webpack_public_path__ + "static/media/eye.c379807e.svg";